<template>
    <div v-if="settings">
        <p class="title is-4">General</p>
        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.key" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>

        <div class="field">
            <p class="title is-4">Double Chance Lotto</p>
            <div class="container">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Ticket Price</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input v-model="settings.doubleChanceLottoSettings.ticketPrice" class="input oc-input" type="number" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Currency</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input v-model="settings.doubleChanceLottoSettings.currency" class="input oc-input" type="text" />
                            </div>
                        </div>
                    </div>
                </div>
                <p class="title is-5">Deposit</p>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Payment Method Id</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input v-model="settings.doubleChanceLottoSettings.payments.deposit.methodId" class="input oc-input" type="text" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <p class="title is-5">Withdrawal</p>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Payment Method Id</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input v-model="settings.doubleChanceLottoSettings.payments.withdrawal.methodId" class="input oc-input" type="text" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="saveSettingsAsync();" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ussdService from "../../../../services/ussd.service";

    export default {
        name: "client-settings-ussd",
        data: () => ({ settings: null }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            this.loadSettingsAsync();
        },
        methods: {
            async loadSettingsAsync() {
                this.settings = await ussdService.getSettingsAsync(this.clientId);
            },
            async saveSettingsAsync() {
                return await ussdService.saveSettingsAsync(this.clientId, this.settings);
            }
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/ussd.vue